import React from 'react'
import { Check, Circle, LockKeyhole, X } from 'lucide-react'
import { LifecyclePhase } from '../../lib/workspace'

function PhaseIcon({ state }: { state: LifecyclePhase['state'] }) {
  if (state === 'complete') return <Check size={12} strokeWidth={3} />
  if (state === 'blocked') return <LockKeyhole size={11} />
  if (state === 'failed') return <X size={12} strokeWidth={3} />
  return <Circle size={9} fill={state === 'active' ? 'currentColor' : 'none'} />
}

export default function LifecycleStepper({ phases }: { phases: LifecyclePhase[] }) {
  return (
    <nav className="lifecycle-stepper" aria-label="Connector lifecycle">
      <ol>
        {phases.map((item, index) => (
          <li key={item.id} className={`lifecycle-step ${item.state}`} aria-current={item.state === 'active' ? 'step' : undefined}>
            <span className="lifecycle-marker"><PhaseIcon state={item.state} /></span>
            <span className="lifecycle-label">{item.label}</span>
            {index < phases.length - 1 && <span className="lifecycle-line" aria-hidden="true" />}
            {(item.state === 'blocked' || item.state === 'failed') && item.reason && (
              <span className="sr-only">{item.reason}</span>
            )}
          </li>
        ))}
      </ol>
      <div className="lifecycle-next-action">
        <span>Next</span>
        <strong>{phases.find(item => ['active', 'blocked', 'failed'].includes(item.state))?.nextAction || 'Continue in chat'}</strong>
      </div>
    </nav>
  )
}
